import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { SharedModule } from '../../shared/shared.module';
import { UtilsModule } from '../../utils/utils.module';
import { AdminComponent } from './admin.component';
import { adminRoutes } from './admin.routing';
import { CustomersComponent } from './customers/customers.component';
import { ResearchPortalAccessDeniedComponent } from './research-portal-access-denied/research-portal-access-denied.component';
import { ResearchPortalStatsComponent } from './research-portal-stats/research-portal-stats.component';
import { ResearchPortalStatsDailyAccessDataComponent } from './research-portal-stats/research-portal-stats-daily-access-data/research-portal-stats-daily-access-data.component';
import { ResearchPortalStatsTotalAccessDataComponent } from './research-portal-stats/research-portal-stats-total-access-data/research-portal-stats-total-access-data.component';
import { ResearchPortalStatsAuditDataComponent } from './research-portal-stats/research-portal-stats-audit-data/research-portal-stats-audit-data.component';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(adminRoutes),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    UtilsModule,
    DropDownsModule,

    GridModule,
    ChartsModule,
    InputsModule,
    TranslateModule,
    BsDatepickerModule.forRoot(),
  ],
  declarations: [
    AdminComponent,
    CustomersComponent,
    ResearchPortalAccessDeniedComponent,
    ResearchPortalStatsComponent,
    ResearchPortalStatsDailyAccessDataComponent,
    ResearchPortalStatsTotalAccessDataComponent,
    ResearchPortalStatsAuditDataComponent,
  ],
  exports: [],
  // providers: [BsDatepickerConfig],
})
export class AdminModule {}
